import { render, staticRenderFns } from "./GarnituresItem.vue?vue&type=template&id=57ad0144&"
import script from "./GarnituresItem.vue?vue&type=script&lang=js&"
export * from "./GarnituresItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports